export const routes = [
  {
    path: '/projeto',
    component: () => import(/* webpackChunkName: "project" */ './components/List'),
    name: 'project.list',
    meta: {
      requiresAuth: true
    }
  }
]
